import {ObjectClassAction} from "./object-class.action";
import {Action, Selector, State, StateContext, Store} from "@ngxs/store";
import {Injectable} from "@angular/core";
import OCAClassBasisInfoTypeStep = ObjectClassAction.OCAClassBasisInfoTypeStep;
import {ObjectClassActionEnum} from "../../../content/components/action/object-class/object-class-action.enum";

export class ObjectClassActionModel {
  classBasisInfoTypeDialogVisible: boolean;
  action: ObjectClassActionEnum;
}

const getDefaults = (): ObjectClassActionModel => ({
  classBasisInfoTypeDialogVisible: false,
  action: null
});


@State<ObjectClassActionModel>({
  name: 'objectClassAction',
  defaults: getDefaults()
})
@Injectable()
export class ObjectClassActionXsState {

  constructor(store: Store) {
  }

  @Selector()
  static classBasisInfoTypeDialogVisible(state: ObjectClassActionModel): boolean {
    return state.classBasisInfoTypeDialogVisible;
  }

  @Action(ObjectClassAction.DefaultInfoDialogVisibility)
  public dialogVisibility(ctx: StateContext<ObjectClassActionModel>, action: ObjectClassAction.DefaultInfoDialogVisibility) {
    ctx.patchState({classBasisInfoTypeDialogVisible: action.visible});
  }

}
